import { navigate } from '../../../helpers/history';

export function navigateToVariantParent({ productId }) {
  navigate(`/product/${productId}`);
}
